import axios, { AxiosError } from 'axios';
import { Api } from '../../axioscadastro';
import { v4 as uuidv4 } from 'uuid';

type NullableDate = Date | null | undefined;

export interface IListagemPedidoDireto {
  idpedido: string;
  emissao: Date;
  numero: string;
  nome: string;
  cpf: string; 
  valor: number;
}

export interface  IitensPedidoDiretoDialog{
  iditens: string;
  idprod: string; 
  idfabrica: string; 
  descricao: string;
  un: string;
  ean: string;
  nome: string;
  quantidade: number;
  codfabrica: string;
  preco: number;
  total: number;
}

interface IgetPedidoDireto {
  idcli: string;
  idoperacao: number;
  dataoperacao: Date;
  emissao: Date; 
  numero: string;
  valor: number;
  status: boolean;
  itens: IitensPedidoDiretoDialog[];
}

interface IDetalhePedidoDireto {
  idcli: string;
  idoperacao: string;
  dataoperacao: Date;
  emissao: Date; 
  numero: number;
  valor: number;
}

interface IItensImpressao{
 descricao: string;
 quantidade: number;
 un: string;
 preco: number;
 total: number;
 ean: string;
 nome: string;
}

interface IItensids{
  iditens: string;
}

interface Iitens{
  iditens: string;
  idprod: string; 
  idfabrica: string; 
  descricao: string;
  un: string;
  ean: string;
  nome: string;
  codfabrica: string;
  quantidade: number;
  preco: number;
  total: number;
}

interface IFabricaImpressao{
  idfabrica: string;
	nome: string;
	logo: string;
  itens: IItensImpressao[];
}

interface IgetImpressao {
  nome: string;
  cpf: string;
  rg: string;
  cep: string;
  endereco: string;
  bairro: string;
  municipio: string;
  uf: string;
  telefone: string;
  descricao: string;
  emissao: Date;
  numero: number;
  valor: number;
  fabricas: IFabricaImpressao[];
}


type TotalCount = {
  data: IListagemPedidoDireto[];
  totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, tipo='', dataInicial = '', dataFinal ='', idcli = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/pedidodireto?page=${page}&limit=${17}&tipo=${tipo}&inicial=${dataInicial}&final=${dataFinal}&participante=${idcli}`;
    const { data, headers } = await Api.get(urlRelativa);  
 
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 17),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (id: string): Promise<IgetPedidoDireto | Error> => {
  try {

    const { data } = await Api.get(`/pedidodireto/${id}`);

    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const getProdutos = async (tipo: string, idfabrica: string, idcli: string, id: string): Promise<IitensPedidoDiretoDialog | Error> => {
  try {
    const { data } = await Api.get(`/produto?idcli=${idcli}&idfabrica=${idfabrica}&tipo=${tipo}&id=${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const create = async (dados: Omit<IDetalhePedidoDireto, 'numero'>, dadositens: IitensPedidoDiretoDialog[]): Promise<string | Error> => {
  try {   
    const guuid = uuidv4();
    const dadosExtraidos = dadositens.map(({ descricao, ean, nome, un, codfabrica, ...restoDoObjeto }) => ({idpedido: guuid, ...restoDoObjeto }));
    const dadosPedido = {idpedido: guuid, ...dados};
    const { data } = await Api.post<IDetalhePedidoDireto>('/pedidodireto',  [dadosPedido, dadosExtraidos]); 
    if (Object.keys(data).length === 0) {  
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const updateById = async (id: string, dados: Omit<IDetalhePedidoDireto, 'numero'>, dadositens: IitensPedidoDiretoDialog[], iddeletados: IItensids[]): Promise<void | Error> => {
  try {

    const dadosExtraidos = dadositens.map(({descricao, ean, nome, un, codfabrica, ...restoDoObjeto }) => ({idpedido: id, ...restoDoObjeto }));
    const { ...dadosIDetalheSaida } = dados;
    const dadosSaida = {idpedido: id, ...dadosIDetalheSaida};

    await Api.put(`/pedidodireto/${id}`, [dadosSaida, dadosExtraidos, iddeletados]);

  }  catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/pedidodireto/${id}`);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const Impressao = async (id: string): Promise<IgetImpressao | Error> => {
  try {

    const { data } = await Api.get(`/pedidodiretoimpressao/${id}`);

    if (data) { 
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

export const PedidoDiretoService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  getProdutos, 
  Impressao,
};